import pL from 'js-regex-pl';

export class RegexProvider {
    static text = new RegExp(`^(?!.*[\u0400-\u04FF])[${pL} ,.'-]*$`);
    // https://emailregex.com
    static email =
        // eslint-disable-next-line
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static address = new RegExp(`^(?!.*[\u0400-\u04FF])[0-9${pL} ,.'-/():]*$`);
    static postalCode = /^(?=.*\d)(?=.*[1-9]).{4}$/;
    static phoneNumber = /^(?!0{8})[0-9]{8}$/;
    static ssn = /^(?!0{8})[0-9]{11}$/;
    static containsNumber = new RegExp(`\\b\\d+`);
}
